import { render, staticRenderFns } from "./BnGepjarmuKivalaszt.vue?vue&type=template&id=2d0c42ab&scoped=true&"
import script from "./BnGepjarmuKivalaszt.vue?vue&type=script&lang=js&"
export * from "./BnGepjarmuKivalaszt.vue?vue&type=script&lang=js&"
import style0 from "./BnGepjarmuKivalaszt.vue?vue&type=style&index=0&id=2d0c42ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c42ab",
  null
  
)

export default component.exports